var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScholIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.697,
    height: 29.697,
    viewBox: "0 0 29.697 29.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0 20.546) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001---Degree",
    "data-name": "001---Degree",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.193,1a10.924,10.924,0,0,1,.374,2.426,3.6,3.6,0,0,0-3.611.336A14.013,14.013,0,0,0,12.6.992q.942.02,1.933.02C15.1,1.012,15.65,1.006,16.193,1ZM15.052,9.311a2.593,2.593,0,1,1,2.593-2.593A2.593,2.593,0,0,1,15.052,9.311ZM.009,4.643A14.548,14.548,0,0,1,.528.234a14.548,14.548,0,0,1,.519,4.409A14.548,14.548,0,0,1,.528,9.052,14.548,14.548,0,0,1,.009,4.643Zm1.568,4.5a17.2,17.2,0,0,0,.507-4.5,17.2,17.2,0,0,0-.507-4.5,91.007,91.007,0,0,0,9.939.821,13.352,13.352,0,0,1,.423,3.677c0,.075,0,.147,0,.219a3.594,3.594,0,0,0-.167,3.4l-.023.055A90.394,90.394,0,0,0,1.577,9.14Zm11.61,3.8-.379-.871a.519.519,0,0,0-.68-.27l-.873.386,1.216-2.916a3.627,3.627,0,0,0,1.832,1ZM17.974,11.8a.519.519,0,0,0-.68.27l-.384.863L15.8,10.271a3.631,3.631,0,0,0,1.834-1l1.214,2.9Zm10.46-2.516a84,84,0,0,0-10.063-.934l-.037-.089a3.61,3.61,0,0,0-.7-4.09,14.437,14.437,0,0,0-.37-3.2A86.581,86.581,0,0,0,28.434,0a12.235,12.235,0,0,1,.622,4.643A12.289,12.289,0,0,1,28.434,9.285Z",
    fill: "#3f2566"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholIcon3);
export default __webpack_public_path__ + "static/media/schol-icon3.8dfd109793caef3e98ed287031ac6a51.svg";
export { ForwardRef as ReactComponent };